import { useEffect, useState } from 'react';
import { Dumbbell } from 'lucide-react';
import { META, ROUTES } from './data';
// IronForge — black scoreboard header, signal-yellow accent
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#0A0A0A] border-b transition-all duration-500 ${scrolled ? 'border-[#F2C500]/40 py-2' : 'border-[#F2C500]/0 py-3'}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3" data-testid="fit-logo">
          <Dumbbell className="w-6 h-6 text-[#F2C500]" strokeWidth={2.4} />
          <div>
            <p className="font-serif text-2xl text-white leading-none">{META.brand}</p>
            <p className="font-mono text-[8px] tracking-[0.4em] uppercase text-white/55">{META.tag}</p>
          </div>
        </button>
        <nav className="hidden lg:flex items-center gap-1">
          {ROUTES.map((r, i) => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`fit-nav-${r.id}`}
              className={`group flex items-baseline gap-2 px-3 py-1.5 font-mono text-[10px] tracking-[0.22em] uppercase transition-colors ${page === r.id ? 'text-[#0A0A0A] bg-[#F2C500]' : 'text-white/65 hover:text-white'}`}>
              <span className="opacity-60">0{i + 1}</span><span>{r.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('trial')} data-testid="fit-cta-trial" className="bg-[#F2C500] text-[#0A0A0A] px-4 py-2 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-white transition-colors">Free trial →</button>
      </div>
    </header>
  );
}
